import { Injectable } from '@angular/core';
// import {CookieService} from 'angular2-cookie/core';
import {Observable} from 'rxjs/Observable';
import {Subject}    from 'rxjs/Subject';

@Injectable()
export class CustomObserverService {
    private _missionAnnouncedSource = new Subject<string>();
    missionAnnounced$ = this._missionAnnouncedSource.asObservable();

    private _name = new Subject<string>();
    name$ = this._name.asObservable();

    private _userId = new Subject<string>();
    userId$ = this._userId.asObservable();

    private _points = new Subject<string>();
    points$ = this._points.asObservable();

    private _tab = new Subject<string>();
    tab$ = this._tab.asObservable();

    private _setItemId = new Subject<string>();
    setItemId$ = this._setItemId.asObservable();
    
    private _className = new Subject<string>();
    className$ = this._className.asObservable();

    private _alert = new Subject<Object>();
    alert$ = this._alert.asObservable();

    private _paymentFlowIcon = new Subject<number>();
    paymentFlowIcon$ = this._paymentFlowIcon.asObservable();

    private _paymentCode = new Subject<boolean>();
    paymentCode$ = this._paymentCode.asObservable();

    private _registrationFee = new Subject<boolean>();
    registrationFee$ = this._registrationFee.asObservable();

    private _subscriptionInfoMsg = new Subject<boolean>();
    subscriptionInfoMsg$ = this._subscriptionInfoMsg.asObservable();

    private _currentPaymentType = new Subject<string>();
    currentPaymentType$ = this._currentPaymentType.asObservable();

    private _currentLanguage = new Subject<string>();
    _currentLanguage$ = this._currentLanguage.asObservable();

    private _subscriptionCount = new Subject<string>();
    subscriptionCount$ = this._subscriptionCount.asObservable();

  /**
   * CookieManagerService constructor
   * depenedecy Injectable
   * @param {CookieService} cookieService
   */
  // constructor(private cookieService: CookieService) {}
  constructor(
  ) {}
  setData(data: any){
    this._missionAnnouncedSource.next(data);
  }

  setName(data: any){
    this._name.next(data);
  }

  setDefaultTab(data: any){
    this._tab.next(data);
  }

  setClassName(data: any){
    this._className.next(data);
  }

  hideNewsAlert(data: Object){
    this._alert.next(data);
  }

  setPoints(data: any){
    this._points.next(data);
  }

  setItemStatus(id: any){
    this._setItemId.next(id);
  }

  setPaymentFlowIcon(no: any){
    this._paymentFlowIcon.next(no);
  }

  setPaymentCode(no: any){
    this._paymentCode.next(no);
  }

  setRegistrationFee(no: any){
    this._registrationFee.next(no);
  }

  setUserId(no: any){
    this._userId.next(no);
  }

  setSubscriptionInfoMsg(no: any){
    this._subscriptionInfoMsg.next(no);
  }

  setCurrentPaymentType(no: any){
    this._currentPaymentType.next(no);
  }

  setCurrentLanguage(no: any){
    this._currentLanguage.next(no);

  }

  setSubscriptionCount(no: any){
    this._subscriptionCount.next(no);

  }

}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/services/custom-observable.service.ts